__turbopack_context__.v({
  "button": "plan-picker-module-scss-module__YP9s0a__button",
  "error": "plan-picker-module-scss-module__YP9s0a__error",
  "grid": "plan-picker-module-scss-module__YP9s0a__grid",
  "red_mark": "plan-picker-module-scss-module__YP9s0a__red_mark",
  "root": "plan-picker-module-scss-module__YP9s0a__root",
  "vat": "plan-picker-module-scss-module__YP9s0a__vat",
});
